export default __webpack_public_path__ + "images/6a586522ec7ba6c52745bb8a5a966dfe.svg";